import { useRouter, type RouteLocationRaw } from 'vue-router'
import { useAuthStore } from '@/features/account/session'

export function useLoginRedirect() {
  const router = useRouter()
  const authStore = useAuthStore()

  const goOrLogin = async (target: RouteLocationRaw): Promise<void> => {
    if (authStore.isAuthenticated) {
      await router.push(target)
      return
    }

    const resolved = router.resolve(target)
    const redirect = resolved.fullPath

    await router.push({
      name: 'login',
      query: { redirect }
    })
  }

  return {
    goOrLogin
  }
}
